import GridContainer from './GridContainer';
import GridRow from './GridRow';
import GridCol from './GridCol';

export { GridContainer as Container, GridRow as Row, GridCol as Col };
export default { Container: GridContainer, Row: GridRow, Col: GridCol };
